import type { UnknownAction } from '@reduxjs/toolkit'
import { authenticationSlice } from 'Flux/Slice/Authentication/AuthenticationSlice.js'
import type { Observable } from 'rxjs'
import { of } from 'rxjs'

/**
 * Turns a 401 into the "please log in again" action, and leaves every other error to the caller's own
 * failure action.
 *
 * There is deliberately nothing to retry. Token refresh happens in the backend, off the refresh-token
 * cookie; the frontend never drove it in this stack. A 401 therefore means the session is gone, not that
 * a refresh might rescue the request.
 *
 * [failedRequest] must be the *request* action's type — it is what clears the pending request from
 * `openRequests`, so passing anything else leaves a spinner running forever.
 */
export const authenticationExpiredOr = ({
  error,
  failedRequest,
  failureAction
}: {
  error: { status?: number }
  failedRequest: string
  failureAction: Observable<UnknownAction>
}): Observable<UnknownAction> =>
  error.status === 401 ? of(authenticationSlice.actions.authenticationExpired({ failedRequest })) : failureAction
